import { useBeyondAccountStatusQuery } from '@/src/api';
import { BEYOND_STATUS, BeyondStatusValue } from '@/src/constants/analytics';
import { BeyondAccountStatus } from '@/src/types/Response';

const deriveBeyondStatus = (
  status: BeyondAccountStatus | undefined,
  hasSmartMeter: boolean,
  hasDirectDebit: boolean,
): BeyondStatusValue | undefined => {
  switch (status) {
    case BeyondAccountStatus.Activated:
      return BEYOND_STATUS.ACTIVATED;
    case BeyondAccountStatus.Enrolled:
      return BEYOND_STATUS.ENROLLED;
    case BeyondAccountStatus.Ineligible:
      return BEYOND_STATUS.INELIGIBLE;
    case BeyondAccountStatus.Prospective: {
      if (!hasSmartMeter && !hasDirectDebit)
        return BEYOND_STATUS.PROSPECTIVE_NO_SMART_OR_DD;
      if (!hasSmartMeter) return BEYOND_STATUS.PROSPECTIVE_NO_SMART;
      if (!hasDirectDebit) return BEYOND_STATUS.PROSPECTIVE_NO_DD;
      return BEYOND_STATUS.ENROLLED;
    }
    default:
      return undefined;
  }
};

export const useBeyondAccountFlags = () => {
  const { data, isLoading, isError, isFetched } = useBeyondAccountStatusQuery();

  const status = data?.beyondAccountStatus?.status;
  const smartMeterStatus = data?.beyondAccountStatus?.smartMeterStatus;
  const directDebitStatus = data?.beyondAccountStatus?.directDebitStatus;

  const hasSmartMeter = smartMeterStatus === 'ACTIVE';
  const hasDirectDebit = directDebitStatus === 'ACTIVE';

  const beyondStatus =
    !isFetched || isError
      ? undefined
      : deriveBeyondStatus(status, hasSmartMeter, hasDirectDebit);

  return {
    hasSmartMeter,
    hasDirectDebit,
    isActivated: status === 'ACTIVATED',
    isIneligible: status === 'INELIGIBLE',
    beyondStatus,
    // Raw enum for the cross-platform Optimizely attribute; `beyondStatus` is Mixpanel display text.
    beyondEligibilityStatus: status,
    isFetched,
    isLoading,
    isError,
  };
};
